<kt-portlet>
  <kt-portlet-header [class]="'card-head-lg'">
    <ng-container ktPortletTitle>
      <span>Login Details</span>
    </ng-container>

    <ng-container ktPortletTools>
      <div *ngIf="result">
        <ng-template ngxPermissionsOnly="canAddContact">
          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="openResetDialog(true)"
            class="mr-5"
          >
            <span class="svg-icon-md">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              Reset Password
            </span>
          </button>
        </ng-template>
        <ng-template ngxPermissionsOnly="canAddContact">
          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="openResetDialog(false)"
            *ngIf="!isViewMode"
          >
            <span class="svg-icon-md">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              Change Username
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>

  <kt-portlet-body>
    <div *ngIf="!loading">
      <kt-contact-credential
        [contact]="contact"
        [isViewMode]="isViewMode"
        (createdCred)="refresh()"
      ></kt-contact-credential>
    </div>
    <div class="" *ngIf="loading">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </kt-portlet-body>
</kt-portlet>
